define('views/shared/header/header',[
	'backbone',
	'views/_base/baseview',
	'text!views/shared/header/header.html',
	'text!views/shared/header/authorizedheader.html',
	'text!views/shared/header/authorizedpartnerheader.html',
	'models/accounts/accountsummary_collection',
	'views/shared/header/balance',
	'views/shared/panel/profile',
	'views/shared/panel/transfer',
	'views/shared/panel/wallet',
	'models/accounts/accounts',
	'views/wallet/pfdebit',
	'views/shared/modal/modal_modern',
	'models/invite/campaign',
], function (
	Backbone,
	BaseView,
	Template,
	AuthorizedTemplate,
	AuthorizedPartnerTemplate,
	AccountSummary,
	AccountBalance,
	Profile,
	Transfer,
	Wallet,
	AccountsModel,
	PfdebitView,
	Modal,
	CampaignModel
) {
	'use strict';

	return BaseView.extend({
		id: 'header-inner-container',
		tagName: 'header',
		mobile_menu_open: false,
		activityIndicator: false,
		events: {
			'click .js-header-mobile-nav-btn': 'showMenuPanel',
			'click .js-profile-logout': 'signOut',
			'click .js-order-pfdebit a': 'showPfDebitModal',
			'click #header-main-links li a': 'updateActiveMenuLink',

			/*
				Temporary Old Links - Will deprecate most if not all
			*/
			// "click #login-link"      : "loginUser",

			'click #register-link': 'goToRegistration',

			'click #mobile-menu-icon': 'showMobileMenu',
			'click #mobile-menu-close-icon': 'closeMobileMenu',
			'click .nav-link': 'closeMobileMenu',
			'click #mobile-menu .nav-link': 'closeMobileMenu',
			'click #pf-logo-icon': 'goToHomeView',
		},

		initialize: function (options) {
			options = options || {};

			var that = this;

			this.header_state = enums.user_state.logged_out;

			this.accounts_interval = null;

			this.site_version = pf.getContent('version.id');

			this.wellness = pf.getFeature(enums.features.wellness);

			pf.session.on('change:auth', function (model, collection, options) {
				that.render();
			});

			if (pf.session.get('auth')) {
				// Get CIP Status if logged in
				this.cip_status = checkCipStatus();
			}

			this.loadPanels();

			pf.globalEvents.on('header_state:Changed', _.bind(this.render, this));

			pf.globalEvents.on('Navigation:Changed', _.bind(this.highlightNav, this));
			pf.globalEvents.on('goToInvitationAccount', function (IA) {
				that.IA = IA;
			});

			BaseView.prototype.initialize(this);
		},

		render: function () {
			var that = this,
				template = null;

			if (
				pf.session.get('auth') &&
				this.header_state != enums.user_state.logged_in
			) {
				template = _.template(AuthorizedTemplate);

				this.$el.html(template());

				this.highlightNav();

				// Temporary fix for Anthem Landing -> PF Inner Views
				this.checkForAnthemDesignAdjustment();

				// Check to see if user is eligible for a GPR
				this.checkGprEligibility();

				// Check invite eligibility if the wellness feature is not present
				if (!this.wellness) {
					this.checkInviteEligibility();
				} else {
					// If the wellness feature is present, remove the reservations link
					this.removeReservations();
				}

				// Add header links
				this.addHeaderLinks();

				// Add profile dropdown photo
				this.addProfileImg();

				// Load accounts and or wellness account
				this.loadAccounts();
			} else {
				if (this.header_state == enums.user_state.logged_in) {
					template = _.template(AuthorizedPartnerTemplate);
				} else {
					template = _.template(Template);
				}

				this.$el.html(template());

				// Generate all of the header link classes
				this.createPartnerClasses();

				// Add main partner class to overall header
				this.addPartnerClass();

				// Add PF and partner logos
				this.addLogos();

				// Add header user links
				if (
					!isSunsetting() &&
					this.site_version !== enums.siteVersion.payforward
				) {
					this.addUserLinks();
				}
			}

			return this;
		},

		goToRegistration: function (e) {
			if (pf.fb_pixel) {
				pf.fb_pixel.checkout();
			}

			pf.navigate($(e.target).attr('href'));

			return false;
		},

		/*

			New Redesign Functions

		*/

		removeReservations: function () {
			this.$('.js-reservations-link').remove();
		},

		addPartnerClass: function () {
			var header_class_name = pf.getContent('header.class');

			this.$('#header-logged-out').addClass(header_class_name);
		},

		createPartnerClasses: function () {
			if (this.site_version == enums.siteVersion.anthem) {
				this.nav_link_class = 'nav-link--abcca';
				this.user_link_class = 'user-link-abcca';
			} else if (this.site_version == enums.siteVersion.bcbsla) {
				this.nav_link_class = 'nav-link--dark';
				this.user_link_class = 'user-link-dark';
			} else if (this.site_version == enums.siteVersion.bcbssc) {
				this.nav_link_class = 'nav-link--dark';
				this.user_link_class = 'user-link-dark';
			} else if (this.site_version == enums.siteVersion.csnp) {
				this.nav_link_class = 'nav-link--dark';
				this.user_link_class = 'user-link-dark';
			} else if (this.site_version == enums.siteVersion.bcbsaz) {
				this.nav_link_class = 'nav-link--dark';
				this.user_link_class = 'user-link-dark';
			} else {
				this.nav_link_class = 'nav-link--accent';
				this.user_link_class = '';
			}
		},

		checkForAnthemDesignAdjustment: function () {
			if (
				$('#mainHeaderWrap').css('position') == 'relative' &&
				this.site_version == enums.siteVersion.anthem
			) {
				$('#mainHeaderWrap').css('position', 'absolute');
			}
		},

		checkGprEligibility: function () {
			if (pf.session.get('CardType') != enums.cardTypes.GPRDebitCard) {
				this.$('.js-order-pfdebit').show();
			}
		},

		addProfileImg: function () {
			var session_img = pf.session.get('PhotoURL'),
				profile_img =
					session_img && session_img != ''
						? session_img
						: 'img/profile/user.png';

			this.$('.js-header-profile-details-img').css({
				background: 'url(' + profile_img + ') no-repeat',
			});
		},

		addLogos: function () {
			var html = [];

			if (this.site_version == enums.siteVersion.bcbsla) {
				html.push(
					'<a href="/" id="partner-logo" class="bcbsla_logo"><img src="img/logos/partners/bcbsla/bcbsla_logo.png" alt="BCBSLA Logo" /></a>'
				);
			} else if (this.site_version == enums.siteVersion.bluekc) {
				html.push(
					'<a href="/" id="partner-logo" class="bluekc_partner_logo">' +
						enums.svg.bluekcDarkLogo +
						'</a>'
				);
			} else if (this.site_version == enums.siteVersion.bcbssc) {
				html.push(
					'<a href="/" id="partner-logo" class="bcbssc_partner_logo">' +
						enums.svg.bcbsscLogo +
						'</a>'
				);
			} else if (this.site_version == enums.siteVersion.csnp) {
				html.push(
					'<a href="/" id="partner-logo" class="csnp_partner_logo">' +
						enums.svg.csnpLogo +
						'</a>'
				);
			} else if (this.site_version == enums.siteVersion.bcbsaz) {
				html.push(
					'<a href="/" id="partner-logo" class="bcbsaz_partner_logo"><img src="img/logos/partners/bcbsaz/bcbsaz_logo_black.png" alt="BCBSAZ Logo" /></a>'
				);
			} else if (this.site_version == enums.siteVersion.bcbsal) {
				html.push(
					'<a href="/" id="partner-logo" class="bcbsal_partner_logo">' +
						enums.svg.bcbsalLogo +
						'</a>'
				);
			} else if (this.site_version == enums.siteVersion.rxsavings) {
				html.push(
					'<a href="/" id="partner-logo" class="bluekc_partner_logo">' +
						enums.svg.rxSavingsLogo +
						'</a>'
				);
			} else if (this.site_version == enums.siteVersion.proteus) {
				html.push(
					'<a href="/" id="partner-logo" class="bluekc_partner_logo">' +
						enums.svg.proteusLogo +
						'</a>'
				);
			}

			// if UHP-CSNP skip adding PF logo

			if (this.site_version !== enums.siteVersion.csnp) {
				if (
					this.site_version == enums.siteVersion.bcbsla ||
					this.site_version == enums.siteVersion.bcbssc
				) {
					html.push(
						'<a href="/" id="pf-logo">' + enums.svg.payForwardLogoBlue + '</a>'
					);
				} else {
					html.push(
						'<a href="/" id="pf-logo">' + enums.svg.payforward_2019 + '</a>'
					);
				}
			}

			// if UHP-CSNP skip adding PF mobile icon
			if (this.site_version !== enums.siteVersion.csnp) {
				html.push(
					'<a href="/" id="pf-logo-icon">' + enums.svg.payforwardIcon + '</a>'
				);
			}

			this.$('.js-nav-links').html(html.join(''));
		},

		addUserLinks: function () {
			var that = this,
				mobile_menu = document.createElement('div'),
				mobile_menu_open_icon = document.createElement('button'),
				mobile_menu_close_icon = document.createElement('button'),
				mobile_logo_icon = document.createElement('span'),
				mm_links = pf.getContent('routes.header.noauth.links'),
				menu = document.createElement('div'),
				m_links = pf.getContent('routes.header.noauth.links');

			mobile_menu.id = 'mobile-menu';
			mobile_logo_icon.id = 'mobile-menu-pf-icon';
			mobile_logo_icon.innerHTML = enums.svg.payforwardIcon;

			mobile_menu.appendChild(mobile_logo_icon);

			mm_links.forEach(function (link) {
				if (link.id == 'shop') {
					link.cls += ' ' + that.nav_link_class;
				}

				if (link.id == 'login-link') {
					link.cls += ' ' + that.user_link_class;
				}

				var anchor = document.createElement('a');

				anchor.id = link.id;
				anchor.className = link.cls;
				anchor.href = link.url;
				anchor.innerHTML = link.text;

				mobile_menu.appendChild(anchor);
			});

			menu.id = 'main-menu';

			m_links.forEach(function (link) {
				if (link.id == 'shop') {
					link.cls += ' ' + that.nav_link_class;
				}

				if (link.id == 'login-link') {
					link.cls += ' ' + that.user_link_class;
				}

				var anchor = document.createElement('a');

				anchor.id = link.id;
				anchor.className = link.cls;
				anchor.href = link.url;
				anchor.innerHTML = link.text;

				menu.appendChild(anchor);
			});

			mobile_menu_open_icon.id = 'mobile-menu-icon';
			mobile_menu_open_icon.innerHTML = enums.svg.mobileMenuIcon;

			mobile_menu_close_icon.id = 'mobile-menu-close-icon';
			mobile_menu_close_icon.innerHTML = enums.svg.mobileCloseMenuIcon;

			this.$('.js-user-links').append(mobile_menu);
			this.$('.js-user-links').append(menu);
			this.$('.js-user-links').append(mobile_menu_open_icon);
			this.$('.js-user-links').append(mobile_menu_close_icon);
		},

		addHeaderLinks: function () {
			var that = this,
				links = pf.getContent('routes.header.auth.links');

			if (_.isArray(links)) {
				links.forEach(function (link) {
					var item = document.createElement('li'),
						inner_item = document.createElement('a');

					if (link.class) {
						item.setAttribute('class', link.class);
					}

					if (link.id) {
						inner_item.setAttribute('id', link.id);
					}

					inner_item.setAttribute('href', '#' + link.url);

					if (link.type == 'html') {
						inner_item.innerHTML = enums.svg.payforwardIcon;
					} else {
						inner_item.innerHTML = link.text;
					}

					item.appendChild(inner_item);

					that.$('.js-header-main-links').append(item);
				});
			}
		},

		loadData: function () {},

		loadAccounts: function () {
			var that = this;

			if (this.wellness) {
				if (!pf.wellness_account) {
					pf.controller.loadWellnessAccount(function () {
						that.addAccountInfo();
					});
				} else {
					this.addAccountInfo();
				}
			} else {
				pf.controller.loadAccounts(function () {
					if (pf.accounts && pf.accounts.spending_account) {
						that.addAccountInfo();
					} else {
						that.accounts_interval = setInterval(function () {
							if (pf.accounts && pf.accounts.spending_account) {
								that.addAccountInfo();
							}
						}, 3000);
					}
				});
			}
		},

		addAccountInfo: function () {
			if (this.wellness) {
				var account = pf.wellness_account,
					proxy_number = account.proxy_number,
					account_card_number = account.card_number;
			} else {
				var account = pf.accounts.spending_account,
					proxy_number = account ? account.proxy_number : '',
					account_card_number = account
						? account.account_name.slice(
								account.account_name.indexOf('Account') + 8
						  )
						: '';
			}

			this.$('.js-profile-account-number').html(proxy_number);
			this.$('.js-profile-card-number').html(account_card_number);

			clearInterval(this.accounts_interval);
		},

		loadPanels: function () {
			require(['views/menu/mobile_menu'], function (MobileMenuView) {
				var mobile_menu_view = new MobileMenuView({
					elementName: '#mobile-menu-container',
				});
				pf.menu = mobile_menu_view;
			});
		},

		createBalance: function () {
			var BalanceView = require('views/shared/header/balance');
			var balance_view = new BalanceView({
				elementName: '.js-pf-account-balance',
			});
			pf.balance = balance_view;
		},

		showMenuPanel: function () {
			this.toggleMobileMenuIcon();
			pf.menu.togglePanel();
		},

		toggleMobileMenuIcon: function () {
			// var snap = Snap('#mobile-menu-transform'),
			//     mobile_open_icon = snap.select('#mobile-open-icon'),
			//     mobile_close_icon = snap.select('#mobile-close-icon'),
			//     open_vector_points = mobile_open_icon.node.getAttribute('d'),
			//     close_vector_points = mobile_close_icon.node.getAttribute('d');

			// var showCloseIcon = function(){
			//     mobile_open_icon.animate({ d: close_vector_points }, 1000, mina.easein, function(el){
			//         console.log('showCloseIcon',el);
			//     });
			// }
			// var showOpenIcon = function(){
			//     mobile_open_icon.animate({ d: open_vector_points }, 1000, mina.easein, function(el){
			//         console.log('showOpenIcon',el);
			//     });
			// }

			if (this.mobile_menu_open) {
				// showOpenIcon();
				this.mobile_menu_open = false;
			} else {
				// showCloseIcon();
				this.mobile_menu_open = true;
			}

			this.$el.find('.js-header-mobile-nav-btn .lines').toggleClass('close');
		},

		showWalletQuickMenu: function () {
			// console.log('showWalletQuickMenu');
			this.$el.find('#header-account-modal-container').show();
		},

		hideWalletQuickMenu: function () {
			this.$el.find('#header-account-modal-container').hide();
		},

		signOut: function (e) {
			if (e && e.preventDefault) {
				e.preventDefault();
			}
			pf.controller.signOut();
		},

		showPfDebitModal: function (e) {
			if (e && e.preventDefault) {
				e.preventDefault();
			}
			if (e && e.stopPropagation) {
				e.stopPropagation();
			}

			// Update the CIP Status because the header may have loaded before CIP occured
			this.cip_status = checkCipStatus();

			if (this.cip_status && pf.IsConsumerFinancial) {
				var pfdebit_form_view = new PfdebitView(),
					modal = new Modal({
						show: true,
						content: pfdebit_form_view.$el.html(),
						calling_view: pfdebit_form_view,
					});
			} else {
				goToFinancialRegistration(pf.getCurrentRoute());
			}
		},

		checkInviteEligibility: function (callback) {
			var that = this;

			this.invite_model = new CampaignModel();
			this.invite_model.fetch({
				success: function (model, resp) {
					var data = that.invite_model.toJSON();

					if (data.CanInvite) {
						that.$('.js-invite-ff').css({ display: 'block' });
					}
				},
				error: function () {},
			});
		},

		updateActiveMenuLink: function (e) {
			this.$('#header-main-links li a').removeClass('active');
			$(e.target).addClass('active');
		},

		highlightNav: function () {
			/*
				TODO look into why the "Navigation:Changed" is not firing on hard reload anymore :`(
			*/

			var links = this.$('#header-main-links li a');

			links.removeClass('active');

			if (location.hash.length) {
				links.each(function (index, el) {
					if (
						$(el)
							.attr('href')
							.replace('#', '')
							.indexOf(location.hash.replace('#', '').split('/')[0]) !== -1
					) {
						$(el).addClass('active');
					}
				});
			}

			if (location.href.indexOf('merchants') !== -1) {
				this.$('.shop').addClass('active');
			}
		},

		/*

			End Redesign Functions

		*/

		/*

			Inherited Functions

		*/

		loginUser: function (e) {
			if (e && e.preventDefault) {
				e.preventDefault();
			}

			$('.loggedOut a.navItem').removeClass('active');

			if (this.IA) {
				pf.navigate('login/' + this.IA);
			} else {
				pf.navigate('login');
			}
		},

		close: function () {
			var that = this;

			pf.session.off('change', function () {
				that.render();
			});
			pf.globalEvents.off('Navigation:Changed', this.highlightNav);
		},

		/*

			End Inherited Functions

		*/

		showMobileMenu: function () {
			this.$('#mobile-menu').fadeIn();
			this.$('#mobile-menu-close-icon').fadeIn();
		},

		closeMobileMenu: function () {
			this.$('#mobile-menu').fadeOut();
			this.$('#mobile-menu-close-icon').fadeOut();
		},

		goToHomeView: function () {
			pf.navigate('');
			this.closeMobileMenu();
		},
	});
});

